/**
 *
 *
 * this.$store.dispatch("groupAuthorities/init")
 *  初期化します。
 *  userDeviceGroupAuthoritiesが存在しない場合にrefreshを呼び出します。
 *  スコープの範囲で1回しか実行されません。
 *
 * this.$store.dispatch("groupAuthorities/refresh")
 *  全userDeviceGroupAuthoritiesを取得しツリー構造に保持します。
 *
 *
 * this.$store.getters["groupAuthorities/getBreadCrumbs"](デバイスグループID)
 *  指定されたデバイスグループIDに対応するuserDeviceGroupAuthoritiesを返します
 *  以下の情報を追加しています
 *   parent    親デバイスグループのuserDeviceGroupAuthorities
 *   children  子デバイスグループのuserDeviceGroupAuthorities(配列)
 *
 * this.$store.getters["getGroup/getBreadCrumbs"](デバイスグループID)
 *  指定されたデバイスグループIDに対応するパンくずのuserDeviceGroupAuthoritiesを配列で返します。
 *
 *
 */

import Vue from 'vue';
import snackbar from '@/store/modules/snackbar';

const getDefaultState = () => {
  return {
    root: undefined,
    allGroups: [],
    allDevices: [],
    deviceCach: [],
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    /**
     * 初期化済み(=デバイスグループ取得済み)であるか？
     * @param {*} state
     * @returns
     */
    getInitialized: (state) => () => {
      return state.root !== undefined;
    },
    /**
     * グループIDからグループを取得
     * @param {} state
     * @returns
     */
    getGroup: (state) => (device_group_id) => {
      const result = state.allGroups.find((v) => v.device_group_id === device_group_id);
      return Object.assign({}, result);
    },
    /**
     * パンくずを取得
     * @param {} state
     * @returns
     */
    getBreadCrumbs: (state) => (device_group_id) => {
      let group = state.allGroups.find((v) => v.device_group_id === device_group_id);
      if (!group) {
        return [];
      }
      let tmp = [];
      tmp.push(group);
      while (group.parent !== undefined) {
        group = group.parent;
        tmp.push(group);
      }
      tmp.reverse();
      return Object.assign([], tmp);
    },
    searchGroup: (state) => async (device_group_id, callback) => {
      console.log('検索開始');
      console.dir(state.deviceCach);
      // 起点となるグループを特定
      const current = state.allGroups.find((v) => v.device_group_id === device_group_id);

      const getDeviceProxy = async (device_group_id) => {
        return await getDeviceBydeviceGroupId(device_group_id, state.allDevices, state.deviceCach);
      };

      const result = await groupWarker(current, callback, getDeviceProxy);
      console.log('検索終了');
      return Object.assign([], result);
    },
    getDeviceBydeviceGroupId: (state) => async (device_group_id) => {
      const result = await getDeviceBydeviceGroupId(device_group_id, state.allDevices, state.deviceCach);
      return Object.assign([], result);
    },
    getDeviceByModelIdSerialNo: (state) => (model_id, serial_no) => {
      const result = state.allDevices.find((el) => el.model_id === model_id && el.serial_no === serial_no);
      return result ? Object.assign({}, result) : undefined;
    },
    get_leaf_group: (state) => (deviceGroupId) => {
      const rootGroup = state.allGroups.find((v) => v.device_group_id === deviceGroupId);
      const leafGroups = [];
      let stack = [];
      // スタックにルートグループを追加
      if (rootGroup) {
        if (rootGroup.children) {
          stack = [...rootGroup.children];
        }
      } else {
        stack = state.allGroups;
      }

      while (stack.length > 0) {
        // stackの最後の要素を取り出してnodeに格納
        const node = stack.pop();
        if (!node.children || node.children.length === 0) {
          // 子ノードがない場合は葉ノードとして追加
          leafGroups.push(node);
        } else {
          // 子ノードがある場合はスタックに追加
          stack.push(...node.children);
        }
      }
      return leafGroups;
    },
    get_all_devices: (state) => {
      return state.allDevices;
    },
  },
  mutations: {
    setRoot(state, payload) {
      state.root = payload[0];
      state.allGroups = payload[1];
      state.allDevices = payload[2];
    },
    clear_state(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    /**
     * 初期化処理
     * @param {} context
     */
    async init(context) {
      console.log('初期化処理');
      if (context.state.root === undefined) {
        context.dispatch('refresh');
      }
    },
    /**
     * 再取得
     * @param {} context
     */
    async refresh(context) {
      const [root, allGroups] = await getDeviceGroup();
      const allDevices = await getAllDevices();
      context.commit('setRoot', [root, allGroups, allDevices]);
    },
  },
};

const groupWarker = async (group, callback, getDeviceProxy) => {
  let result = [];
  // コールバックを実行して対象グループを特定
  const tmp = await callback(group, getDeviceProxy);
  if (tmp) {
    result = result.concat(tmp);
  }

  // 再帰で下層も取得
  if (group.children) {
    for (const child of group.children) {
      const childResult = await groupWarker(child, callback, getDeviceProxy);
      result = result.concat(childResult);
    }
  }
  return result;
};

const getAllDevices = async () => {
  console.info('API開始 device');
  try {
    let tmp = [];
    const proxy = new Vue();
    proxy.modules = {
      snackbar,
    };
    //モデルIDを取得
    const models = await proxy.apiRequest('/v1/master-info/baseDevices', 'GET', {
      fields: 'model_id',
    });

    for (const model of models) {
      const devices = await proxy.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
        model_id: model.model_id,
      });
      if (devices) {
        tmp = tmp.concat(devices.filter((el) => el));
      }
    }
    return tmp;
  } catch (error) {
    console.error(error);
  } finally {
    console.info('API完了 device');
    //this.$store.commit("loading/end_loading")
  }
};

const getDeviceBydeviceGroupId = async (device_group_id, allDevices, deviceCach) => {
  const cache = deviceCach[device_group_id];
  if (cache) {
    return cache;
  }

  // if (allDevices.length === 0) {
  //     // 一気に全データを取得したほうが応答待ち時間が少ない
  //     allDevices = await getAllDevices()
  // }

  const result = allDevices.filter((el) => el.device_group_id === device_group_id);
  deviceCach[device_group_id] = result;
  return result;
};

const getDeviceGroup = async () => {
  //this.$store.commit("loading/start_loading")

  console.info('API開始 deviceGroup');
  try {
    // apiRequestを呼び出すためのプロキシ
    const proxy = new Vue();
    const res = await proxy.apiRequest('/v1/master-info/userDeviceGroupAuthorities', 'GET', {});
    const groups = res;
    // ルートグループを特定 一つしか存在しえないはず
    const rootGroupId = groups[0].root_group_id;
    const root = groups.filter((group) => {
      return group.device_group_id === rootGroupId;
    })[0];

    root.children = getChildren(groups, root);

    return [root, res];
  } catch (error) {
    console.error(error);
    // // トークン切れの場合は401
    // console.log(`Error! HTTP Status: ${status} ${statusText}`)
  } finally {
    console.info('API完了 deviceGroup');
    //this.$store.commit("loading/end_loading")
  }
};
const getChildren = (groups, currentGroup) => {
  const children = groups.filter((group) => {
    return group.parent_device_group_id === currentGroup.device_group_id;
  });

  children.forEach((element) => {
    // 検索用に参照を保持

    // パンくずに使うので子→親もたどれるように設定
    element.parent = currentGroup;
    element.children = getChildren(groups, element);
  });
  return children;
};
